/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [spinner.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 06.01.20, 14:11
 */
import React from 'react';
import {SpinnerIcon} from "../navigation/icons/nav-icons";
import {cn} from "./text-utils";

export const Spinner = ({className, ...otherProps}) => {
    return <div className='spinner' {...otherProps}>
        <SpinnerIcon className={cn('font-1x icon-spin', [className])}/>
    </div>
};

export const SpinnerBig = ({children, className, ...otherProps}) => {
    return <div className='spinner' {...otherProps}>
        <SpinnerIcon className={cn('font-2x icon-spin', [className])}/>
        {children}
    </div>
};